import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getRegisteredUsers, confirmDeleteRegisteredUser } from '../../services/authService';
import { getCookie } from "../../utils/cookieUtil";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

const LoadingSpinner = () => (
    <div className="fixed inset-0 flex h-full items-center justify-center  bg-opacity-50 z-50">
        <div className="w-16 h-16 border-t-4 border-[#900028] border-solid rounded-full animate-spin"></div>
    </div>
);

function RegisteredUsers({ counter, searchMailQuery, selectedIds, setSelectedIds, selectedGroup, }) {
    const [registeredUsers, setRegisteredUsers] = useState([]);
    const [loading, setDataLoading] = useState(false);
    const [permission, setPermission] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [userToDelete, setUserToDelete] = useState(null);
    const [activeDropdown, setActiveDropdown] = useState(null);




    const dropdownRef = useRef(null);

    const itemsPerPage = 10;
    const navigate = useNavigate();
    useEffect(() => {
        setCurrentPage(1);
    }, [searchMailQuery]);

    useEffect(() => {
        setCurrentPage(1);
    }, [selectedGroup]);


    useEffect(() => {
        fetchUsers({ search: searchMailQuery, group: selectedGroup });
    }, [counter, searchMailQuery, selectedGroup]);




    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setActiveDropdown(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownRef]);







    useEffect(() => {
        const roles = getCookie('roleId');
        if (roles) {
            setPermission(roles);
        }
    }, []);

    const toggleDropdown = (uid) => {
        setActiveDropdown((prev) => (prev === uid ? null : uid));
    };

    const fetchUsers = async () => {
        setDataLoading(true);
        try {
            const res = await getRegisteredUsers();
            const data = await res.json();
            setRegisteredUsers(data.users);
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setDataLoading(false);
        }
    };

    const handleViewClick = (id) => {
        navigate(`/app/userdetails?uid=${id}`);

    };

    const handleDeleteClick = (uid) => {
        setUserToDelete(uid);
        setShowConfirmationModal(true);
    };

    const confirmDelete = async () => {
        try {
            setDataLoading(true);
            await confirmDeleteRegisteredUser(userToDelete);
            setShowConfirmationModal(false);
            setUserToDelete(null);
            fetchUsers();
        } catch (error) {
            console.error('[ERROR] Failed to complete deletion process:', error);
        } finally {
            setDataLoading(false);
        }
    };

    const cancelDelete = () => {
        setShowConfirmationModal(false);
        setUserToDelete(null);
    };



    const filteredUsers = registeredUsers.filter((user) => {
        const emailMatch = user?.email?.toLowerCase().includes(searchMailQuery.toLowerCase());
        const groupMatch = selectedGroup && selectedGroup !== "All Groups"
            ? user?.group?.toLowerCase().includes(selectedGroup.toLowerCase())
            : true;
        return emailMatch && groupMatch;
    });



    const startIndex = (currentPage - 1) * itemsPerPage;
    const currentUsers = filteredUsers.slice(startIndex, startIndex + itemsPerPage);
    const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);

    // const goToPreviousPage = () => {
    //     setCurrentPage((prev) => Math.max(prev - 1, 1));
    // };

    const goToNextPage = () => {
        setCurrentPage((prev) => Math.min(prev + 1, totalPages));
    };


    const handleCheckboxChange = (id) => {
        setSelectedIds((prev) => {
            const registered = prev?.registered ?? [];
            const alreadySelected = registered.includes(id);

            return {
                ...prev,
                registered: alreadySelected
                    ? registered.filter((e) => e !== id)
                    : [...registered, id],
            };
        });
    };



    const handleSelectAll = () => {
        const visibleIds = filteredUsers.map((user) => user.id);

        setSelectedIds((prev) => {
            const registered = prev?.registered ?? [];
            const allSelected = visibleIds.every((id) => registered.includes(id));

            return {
                ...prev,
                registered: allSelected
                    ? registered.filter((id) => !visibleIds.includes(id))
                    : [...new Set([...registered, ...visibleIds])],
            };
        });
    };

return (
        <div className="flex-1 relative  overflow-x-autopx-4 py-4" ref={dropdownRef}>
           

            <div className="relative w-full ">
                <table className="w-full table-fixed text-sm text-left text-gray-900">
                    <thead className="text-xs bg-gray-200 uppercase">
                        <tr >
                            <th className="w-8 p-2">
                                <input
                                    type="checkbox"
                                    checked={
                                        filteredUsers.length > 0 &&
                                        filteredUsers.every((u) => (selectedIds.registered ?? []).includes(u.id))
                                    }
                                    onChange={handleSelectAll}
                                   className="w-4 h-4" style={{ accentColor: '#900028' }}

                                />

                            </th>
                            {permission.includes("adduser") && (
                                <>
                                    <th className="w-24 px-2 py-2">FIRST NAME</th>
                                    <th className="w-24 px-2 py-2">LAST NAME</th>
                                    <th className="w-24 px-2 py-2 truncate">EMAIL</th>
                                </>
                            )}
                            <th className="w-5 pr-4 px-2 py-2 text-left">GROUP</th>
                            <th className="w-14 px-6 py-2">UID</th>

                            <th className="w-10 px-2 py-2 text-center">ACTIONS</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentUsers.map((user) => (
                            <tr key={user.uid} className="border-b hover:bg-gray-50   text-xs h-5">
                                <td className="p-2">
                                    <input
                                        type="checkbox"
                                        checked={(selectedIds.registered ?? []).includes(user.id)}
                                        onChange={() => handleCheckboxChange(user.id)}
                                      className="w-4 h-4" style={{ accentColor: '#900028' }}

                                    />

                                </td>
                                {permission.includes("adduser") && (
                                    <>
                                        <td className="px-2 py-1 truncate">  {user.name?.firstName?.charAt(0).toUpperCase() + user.name?.firstName?.slice(1)}</td>
                                        <td className="px-2 py-1 truncate">  {user.name?.secondName?.charAt(0).toUpperCase() + user.name?.secondName?.slice(1)}</td>
                                        <td className="px-2 py-1 truncate">{user.email}</td>
                                    </>
                                )}
                                <td className="px-2 py-1 truncate">{user.group}</td>
                                <td className="px-5 py-1 truncate">{user.uid}</td>
                                <td className="px-2 py-1 text-center relative">
                                    <div className="inline-block text-left"  >
                                        <button
                                            className="text-gray-600 hover:bg-gray-200 p-1 rounded"
                                            onClick={() => toggleDropdown(user.id)}
                                        >
                                            &#x22EE;
                                        </button>
                                        {activeDropdown === user.id && (
                                            <div className="absolute right-0 z-10 mt-2 w-20 bg-white border ">
                                                <button
                                                    className="block w-full px-4 py-2 text-sm text-black-600 hover:bg-gray-100"
                                                    onClick={() => handleViewClick(user.id)}
                                                >
                                                    View
                                                </button>
                                                <button
                                                    className="block w-full px-4 py-2 text-sm text-black-600 hover:bg-gray-100"
                                                    onClick={() => handleDeleteClick(user.id)}
                                                >
                                                    Delete
                                                </button>
                                            </div>
                                        )}
                                    </div>

                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                  {loading && <LoadingSpinner />}
            </div>


            {/* Pagination */}
            <div className="flex justify-center items-center mt-4 gap-1">
                {/* Page Buttons (max 6 visible) */}
                {(() => {
                    const maxVisible = 6;
                    let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
                    let endPage = startPage + maxVisible - 1;

                    if (endPage > totalPages) {
                        endPage = totalPages;
                        startPage = Math.max(1, endPage - maxVisible + 1);
                    }

                    const pages = [];
                    for (let i = startPage; i <= endPage; i++) {
                        pages.push(
                            <button
                                key={i}
                                onClick={() => setCurrentPage(i)}
                                className={`px-3 py-1 text-sm rounded
                        ${currentPage === i
                                        ? 'font-bold text-black'
                                        : 'text-gray-700 hover:bg-gray-200'}`}
                            >
                                {i}
                            </button>
                        );
                    }
                    return pages;
                })()}

                {/* Right Arrow */}
                <button
                    onClick={goToNextPage}
                    disabled={currentPage === totalPages}
                    className={`px-3 py-1 flex items-center ${currentPage === totalPages ? 'text-gray-400 cursor-not-allowed' : 'hover:bg-gray-100'
                        }`}
                >
                    <FontAwesomeIcon icon={faChevronRight} />
                </button>
            </div>
            {/* Confirmation Modal */}
            {showConfirmationModal && (
                <div className="fixed inset-0 z-50 bg-black bg-opacity-40 backdrop-blur-sm flex items-center justify-center px-4">
                    <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md p-6 transition-all duration-300 ease-in-out animate-fade-in">
                        <h3 className="text-xl font-semibold text-gray-900 mb-3">Confirm Deletion</h3>
                        <p className="text-gray-600 mb-6">
                            Are you sure you want to permanently delete this user?
                        </p>
                        <div className="flex justify-end gap-3">
                            <button
                                onClick={cancelDelete}
                                className="px-5 py-2 text-sm font-semibold text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg transition duration-200"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={() => confirmDelete(userToDelete)}
                                className="px-5 py-2 text-sm font-semibold text-white bg-red-600 hover:bg-red-700 rounded-lg shadow-sm transition duration-200"
                            >
                                Yes, Delete
                  {loading && <LoadingSpinner />}
                            </button>
                        </div>

                    </div>
                    
                </div>

            )}
       
       
        </div>
    );
}

export default RegisteredUsers;

















